module.exports = __webpack_public_path__ + "img/ValoresVF.aa3a112a.jpg";